import { USER_INFO } from '../actions';



export default function(state = {}, action) {
  switch (action.type) {
  case USER_INFO:
    if (!action.error) {
      // ??? Not sure what this is supposed to be
      // Group is not a key of the 
      sessionStorage.setItem('user', action.payload.data.user.group);
      // Used just for the MBB -> FF field hiding
      sessionStorage.setItem('userID', action.payload.data.user.id);
      sessionStorage.setItem('userName', action.payload.data.user.username);
      sessionStorage.setItem('firstName', action.payload.data.user.firstname);
      return action.payload.data.user;
    }
    return {error: action.error};
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_user.js